import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MediaCard from '../components/media-card/MediaCard';
import UploadZone from '../components/upload-zone/UploadZone';
import useGridElementsCount from '../../../hooks/useGridElementsCount';
import useActiv8TagsOptions from '../../../hooks/useActiv8TagsOptions';
import VirtualMasonryGrid from './virtual-masonry/VirtualMasonryGrid';

import scss from './MediaGrid.module.scss';

const MediaGrid = forwardRef(function MediaGrid(
  {
    mediaItems,
    onUploadMediaItems,
    onChangeMediaItems,
    duplicates,
    onClearDuplicates,
    onChangeErrors,
    onMediaErrorLoading,
  },
  ref,
) {
  const { t } = useTranslation('activ8');

  const colCount = useGridElementsCount();

  const [copiedTags, setCopiedTags] = useState([]);

  const allTagsOptions = useActiv8TagsOptions();

  const handleRemoveItem = (itemId) => {
    onChangeMediaItems((prev) => {
      const item = prev.find((i) => i.id === itemId);
      if (item?.preview) URL.revokeObjectURL(item.preview);
      return prev.filter((i) => i.id !== itemId);
    });
  };

  const handleCopyTags = (itemId) => {
    const item = mediaItems.find((i) => i.id === itemId);
    setCopiedTags(item.tags);
  };

  const handlePasteTags = (itemId) => {
    const item = mediaItems.find((i) => i.id === itemId);
    const newTags = [...new Set([...item.tags, ...copiedTags])];
    onChangeMediaItems((prev) => prev.map((i) => (i.id === itemId ? { ...i, tags: newTags } : i)));
  };

  const handleUpdateItemTags = (itemId, tags) => {
    onChangeMediaItems((prev) => prev.map((item) => (item.id === itemId ? { ...item, tags } : item)));
  };

  const handleUpdateItemThirdPartyRights = (itemId, thirdPartyRights) => {
    onChangeMediaItems((prev) => prev.map((item) => (item.id === itemId ? { ...item, thirdPartyRights } : item)));
  };

  const handleUpdateItemExpirationDate = (itemId, expirationDate) => {
    onChangeMediaItems((prev) => prev.map((item) => (item.id === itemId ? { ...item, expirationDate } : item)));
  };

  return (
    <div className={scss.wrapper}>
      <VirtualMasonryGrid
        ref={ref}
        items={mediaItems}
        columns={colCount}
        gap={8}
        padding={12}
        style={{ maxHeight: 600 }}
        estimateHeight={240}
        overscanPx={800}
        renderItem={(item) => (
          <MediaCard
            key={item.id}
            item={item}
            onRemoveItem={handleRemoveItem}
            onUpdateItemTags={handleUpdateItemTags}
            onUpdateItemThirdPartyRights={handleUpdateItemThirdPartyRights}
            onUpdateItemExpirationDate={handleUpdateItemExpirationDate}
            allTagsOptions={allTagsOptions}
            onCopyTags={handleCopyTags}
            onPasteTags={handlePasteTags}
            duplicates={duplicates[item.id]}
            onClearDuplicates={onClearDuplicates}
            onMediaErrorLoading={onMediaErrorLoading}
          />
        )}
      />
      {/* <div className={scss.grid}>
        {mediaItems.map((item) => (
          <MediaCard
            key={item.id}
            item={item}
            onRemoveItem={handleRemoveItem}
            onUpdateItemTags={handleUpdateItemTags}
          />
        ))}
      </div> */}

      <div className={scss.uploadWrapper}>
        <UploadZone
          onUploadMediaItems={onUploadMediaItems}
          subLabelText={t('uploadMoreMediaFiles')}
          iconSize='2rem'
          flexDirection='row'
          onChangeErrors={onChangeErrors}
        />
      </div>
    </div>
  );
});

export default MediaGrid;
